import React from "react"
import { navigate } from "gatsby"

import { AirtableApi } from "../../helpers/AirtableApi"

import { ChildSelector } from "../../helpers/ChildSelector"

import * as tm1paConference2025RegistrationFormStyles from "../../styles/landing_pages/TM1PAConference2025RegistrationForm.module.css"

const ISOCountries = require("i18n-iso-countries")
ISOCountries.registerLocale(require("i18n-iso-countries/langs/en.json"))

const _lt = (str, lang = `en`) => {
  switch (str) {
    case `firstName`:
      return lang === `fr` ? `Prénom` : `First Name`
    case `lastName`:
      return lang === `fr` ? `Nom` : `Last Name`
    case `company`:
      return lang === `fr` ? `Entreprise` : `Company`
    case `businessEmail`:
      return lang === `fr` ? `Email` : `Business Email`
    case `jobPosition`:
      return lang === `fr` ? `Poste` : `Job Position`
    case `contactNumber`:
      return lang === `fr` ? `Numéro de contact` : `Contact Number`
    case `dietaryRestrictions`:
      return lang === `fr`
        ? `Restrictions alimentaires`
        : `Dietary Restrictions`
    case `postEvent`:
      return lang === `fr`
        ? `Vous rejoindrez-vous pour le réseautage post-événement à partir de 17:30 ?`
        : `Will you be joining us for post-event networking from 5:30 pm onwards?`
    case `whatVersionOfTM1PlanningAnalyticsAreYouUsing`:
      return lang === `fr`
        ? `Version de TM1 Planning Analytics que vous utilisez`
        : `What version of TM1 Planning Analytics are you using?`
    case `doesYourOrganisationPlanToMoveToACloudBasedSolutionForPlanningAnalytics`:
      return lang === `fr`
        ? `Votre organisation prévoit-elle de se déplacer vers une solution de planification cloud pour TM1 Planning Analytics?`
        : `Does your organisation plan to move to a Cloud based solution for Planning Analytics?`
    case `selectTheOptionThatBestDescribesYourOrganisation`:
      return lang === `fr`
        ? `Sélectionnez l'option qui correspond le mieux à votre organisation`
        : `Select the option that best describes your organisation`
    case `whatPartsOfTheValueChainDoesTM1PlanningAnalyticsCurrentlyCoverInYourOrganisation`:
      return lang === `fr`
        ? `Quelles parties de la chaîne de valeur couvre actuellement TM1 Planning Analytics dans votre organisation?`
        : `What parts of the value chain does TM1 Planning Analytics currently cover in your organisation?`
    case `whichFrontEndsDoYouUseInYourNormalWorkflow`:
      return lang === `fr`
        ? `Quels front-ends utilisez-vous dans votre workflow normal?`
        : `Which FrontEnds do you use in your normal workflow?`
    case `doYouSeeADemandForAIMLInYourApplicationWhatProblemsShouldBeSolvedAddressedWithIt`:
      return lang === `fr`
        ? `Voulez-vous que nous vous contactions pour plus d'informations sur nos produits et services?`
        : `Do you want us to contact you for more information about our products and services?`
    case `wePlanToOrganiseIndustryRoundTablesWhatFocusGroupWouldYouLikeToSeeOnTheAgenda`:
      return lang === `fr`
        ? `Quel groupe de discussion souhaitez-vous voir sur l'agenda?`
        : `What Focus Group would you like to see on the agenda?`
    case `whatOtherTopicsWouldYouLikeToDiscussWithYourPeers`:
      return lang === `fr`
        ? `Quels autres sujets aimeriez-vous discuter avec vos pairs?`
        : `What other topics would you like to discuss with your peers?`
    case `wouldYouBeWillingToBeInterviewedAtTheConferencePleaseNoteAnyRecordingsMayBeUsedByCubewiseForMarketingPurposes`:
      return lang === `fr`
        ? `Souhaitez-vous être interviewé(e) au cours du congrès? Notez que toute enregistrement peut être utilisé par Cubewise pour des fins de marketing.`
        : `Would you be willing to be interviewed at the conference? Please note any recordings may be used by Cubewise for marketing purposes.`
    case `mandatoryFields`:
      return lang === `fr` ? `Champs obligatoires` : `Mandatory fields`
    case `marketingAuthorisation`:
      return lang === `fr`
        ? `Nous aimerions obtenir votre permission de vous contacter avec des informations supplémentaires sur nos produits et services. Nous ne vous enverrons que des informations pertinentes et nous ne vendrons pas vos informations personnelles.`
        : `We would like your permission to reach out to you with more information about our products and services. We will only send you information we think will be relevant to you. We will always treat your personal details with the utmost care and will never sell them to other companies for marketing purposes.`
    case `mediaPermission`:
      return lang === `fr`
        ? `En participant à cet événement, vous reconnaissez et acceptez que des photographies, vidéos et enregistrements audio soient pris tout au long de la journée. Ces enregistrements peuvent être utilisés par Cubewise pour des fins promotionnelles, éducatives ou de marketing, y compris mais sans s'y limiter, via les réseaux sociaux, les sites web et d'autres publications.`
        : `By attending this event, you acknowledge and agree that photography, video, and audio recordings may be taken throughout the day. These recordings may be used by Cubewise for promotional, educational, or marketing purposes, including but not limited to social media, websites, and other publications.`
    case `register`:
      return lang === `fr` ? `S'inscrire` : `Register`
    case `anUnexpectedErrorHasOccurredPleaseConfirmAllDataToBeCorrectlyInputAndTryAgain`:
      return lang === `fr`
        ? `Une erreur inattendue est survenue. Veuillez confirmer que tous les données sont correctement saisies et réessayer...`
        : `An unexpected error has occurred. Please confirm all data to be correctly input and try again...`
    case `thankYouForYourInterestYouWillReceiveAnEmailWithTheConferenceDetails`:
      return lang === `fr`
        ? `Merci pour votre intérêt ! Vous recevrez un e-mail sous peu avec un suivi.`
        : `Thank you for your interest! You will receive an e-mail shortly with a follow up.`
    default:
      return str
  }
}

const DEFAULT_LOCATION = `sydney`
const SUPPORTED_LOCATIONS = [
  `london`,
  `melbourne`,
  `melbourne2`,
  `sydney`,
  `paris`,
  `benelux`,
]

export default function TM1PAConference2025RegistrationForm(props) {
  const { content } = props

  const [, forceUpdate] = React.useReducer(x => x + 1, 0)

  const [isSubmitting, setSubmitting] = React.useState(false)
  const [isSubmitted, setSubmitted] = React.useState(false)
  const [hasError, setHasError] = React.useState(false)

  const location = getLocation(props.className || ``)
  const language = getLanguage(location)

  const [data, setData] = React.useState(getLocationData(location))

  const handleItemChange = (evt, cat, singleSelect = false) => {
    let updated = data
    if (Object.keys(evt.target).includes(`checked`)) {
      if (cat) {
        if (singleSelect)
          updated[cat].forEach(it => {
            it.checked = false
          })
        updated[cat].find(({ name }) => name === evt.target.name).checked =
          evt.target.checked
      } else {
        updated[evt.target.name] = evt.target.checked
      }
    } else {
      updated[evt.target.name] = evt.target.value
    }

    setData(updated, forceUpdate())
  }

  const handleSubmit = async (evt, location) => {
    evt.preventDefault()

    setHasError(false)
    setSubmitting(true)

    try {
      let filteredData = JSON.parse(JSON.stringify(data))
      filteredData = {
        ...filteredData,
        ...handleLocationData(location, filteredData),
      }

      // handle post event item special case
      if (filteredData[`postEvent`])
        filteredData[`postEvent`] = filteredData[`postEvent`].split(`-`)[1]

      const { airtableId, airtableName } =
        getAirtableSettingsByLocation(location)

      const records = await AirtableApi.writeRecord(
        process.env.GATSBY_AIRTABLE_API_TOKEN,
        airtableId,
        airtableName,
        filteredData,
      )

      const record = records && records.records && records.records[0]
      const submittedPage = record && record.fields[`thankYouPage`]

      setHasError(false)
      setSubmitting(false)
      setSubmitted(true)

      navigate(submittedPage)
    } catch (error) {
      console.error(error)

      setHasError(true)
      setSubmitting(false)
    }
  }

  const title = ChildSelector.select(
    content,
    `title`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const info = content.childNodes
    .filter(node => node.classNames === "text")
    .map(t => t.innerHTML)

  return (
    <>
      <div
        className={`row ${tm1paConference2025RegistrationFormStyles.wrapper} ${props.className}`}
      >
        <div
          id={props.componentOriginalId || ``}
          className={`row ${tm1paConference2025RegistrationFormStyles.formSubmitWrapper}`}
        >
          <div
            className={`col ${tm1paConference2025RegistrationFormStyles.formSubmit}`}
          >
            <h2>{title}</h2>
            {info.map((t, idx) => (
              <p
                dangerouslySetInnerHTML={{ __html: t }}
                className={tm1paConference2025RegistrationFormStyles.main}
                key={idx}
              />
            ))}

            <form
              className={`row ${tm1paConference2025RegistrationFormStyles.form}`}
              onSubmit={evt => handleSubmit(evt, location)}
            >
              <div
                className={`col ${tm1paConference2025RegistrationFormStyles.personalInfo}`}
              >
                <label htmlFor="firstName">
                  {_lt(`firstName`, language)} *
                </label>
                <input
                  id="firstName"
                  type="text"
                  className="form-control"
                  name="firstName"
                  value={data.firstName}
                  required
                  pattern="\S(.*\S)?"
                  onChange={handleItemChange}
                />
              </div>
              <div
                className={`col ${tm1paConference2025RegistrationFormStyles.personalInfo}`}
              >
                <label htmlFor="lastName">{_lt(`lastName`, language)} *</label>
                <input
                  id="lastName"
                  type="text"
                  className="form-control"
                  name="lastName"
                  value={data.lastName}
                  required
                  pattern="\S(.*\S)?"
                  onChange={handleItemChange}
                />
              </div>
              <div
                className={`col ${tm1paConference2025RegistrationFormStyles.personalInfo}`}
              >
                <label htmlFor="company">{_lt(`company`, language)} *</label>
                <input
                  id="company"
                  type="text"
                  className="form-control"
                  name="company"
                  value={data.company}
                  required
                  pattern="\S(.*\S)?"
                  onChange={handleItemChange}
                />
              </div>
              <div
                className={`col ${tm1paConference2025RegistrationFormStyles.personalInfo}`}
              >
                <label htmlFor="businessEmail">
                  {_lt(`businessEmail`, language)} *
                </label>
                <input
                  id="businessEmail"
                  type="email"
                  className="form-control"
                  aria-label="Email"
                  name="businessEmail"
                  value={data.businessEmail}
                  required
                  pattern="\S(.*\S)?"
                  onChange={handleItemChange}
                />
              </div>
              <div
                className={`col ${tm1paConference2025RegistrationFormStyles.personalInfo}`}
              >
                <label htmlFor="jobPosition">
                  {_lt(`jobPosition`, language)}
                  {location !== `benelux` ? ` *` : ``}
                </label>
                <input
                  id="jobPosition"
                  type="text"
                  className="form-control"
                  aria-label="JobPosition"
                  name="jobPosition"
                  value={data.jobPosition}
                  required={location !== `benelux` ? true : false}
                  pattern="\S(.*\S)?"
                  onChange={handleItemChange}
                />
              </div>
              {location === `london` && (
                <div
                  className={`col ${tm1paConference2025RegistrationFormStyles.country}`}
                >
                  <label>
                    {_lt(`country`, language)} *
                    <select
                      value={data.country}
                      name="country"
                      required
                      onChange={handleItemChange}
                    >
                      <option value="" disabled defaultValue="">
                        Select a country
                      </option>
                      {Object.entries(
                        ISOCountries.getNames("EN", {
                          select: "official",
                        }),
                      ).map((country, idx) => (
                        <option key={idx} value={country[0]}>
                          {country[1]}
                        </option>
                      ))}
                    </select>
                  </label>
                </div>
              )}
              <div
                className={`col ${tm1paConference2025RegistrationFormStyles.personalInfo}`}
              >
                <label htmlFor="contactNumber">
                  {_lt(`contactNumber`, language)} *
                </label>
                <input
                  id="contactNumber"
                  type="text"
                  className="form-control"
                  aria-label="ContactNumber"
                  name="contactNumber"
                  value={data.contactNumber}
                  required
                  pattern="\S(.*\S)?"
                  onChange={handleItemChange}
                />
              </div>
              <div
                className={`col ${tm1paConference2025RegistrationFormStyles.message}`}
              >
                <label htmlFor="dietaryRestrictions">
                  {_lt(`dietaryRestrictions`, language)}
                  {location !== `benelux` ? ` *` : ``}
                </label>
                <textarea
                  className="form-control"
                  name="dietaryRestrictions"
                  rows="3"
                  required={location !== `benelux` ? true : false}
                  pattern="\S(.*\S)?"
                  values={data.dietaryRestrictions}
                  onChange={handleItemChange}
                ></textarea>
              </div>

              {location !== `paris` && location !== `sydney` && location !== `melbourne` && location !== `melbourne2` && (
                <div
                  className={`col ${tm1paConference2025RegistrationFormStyles.postEvent}`}
                >
                  <label>{_lt(`postEvent`, language)} *</label>
                  <div
                    className={
                      tm1paConference2025RegistrationFormStyles.optionsWrapper
                    }
                  >
                    {data.postEvent.map((it, idx) => (
                      <div
                        key={idx}
                        className={`col ${tm1paConference2025RegistrationFormStyles.options}`}
                      >
                        <input
                          className="form-check-input"
                          type="radio"
                          name={it.name}
                          checked={data.postEvent[idx].checked}
                          onChange={evt =>
                            handleItemChange(evt, `postEvent`, true)
                          }
                        />
                        <label className="form-check-label">
                          {it.name.split(`-`)[1]}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {location === `london` && (
                <>
                  <div
                    className={`col ${tm1paConference2025RegistrationFormStyles.tm1version}`}
                  >
                    <label htmlFor="whatVersionOfTM1PlanningAnalyticsAreYouUsing">
                      {_lt(
                        `whatVersionOfTM1PlanningAnalyticsAreYouUsing`,
                        language,
                      )}
                    </label>
                    <input
                      id="whatVersionOfTM1PlanningAnalyticsAreYouUsing"
                      type="text"
                      className="form-control"
                      aria-label="What version of TM1 Planning Analytics are you using?"
                      name="whatVersionOfTM1PlanningAnalyticsAreYouUsing"
                      value={data.whatVersionOfTM1PlanningAnalyticsAreYouUsing}
                      pattern="\S(.*\S)?"
                      onChange={handleItemChange}
                    />
                  </div>

                  <div
                    className={`col ${tm1paConference2025RegistrationFormStyles.cloudMove}`}
                  >
                    <label>
                      {_lt(
                        `doesYourOrganisationPlanToMoveToACloudBasedSolutionForPlanningAnalytics`,
                        language,
                      )}
                      <select
                        value={
                          data.doesYourOrganisationPlanToMoveToACloudBasedSolutionForPlanningAnalytics
                        }
                        name="doesYourOrganisationPlanToMoveToACloudBasedSolutionForPlanningAnalytics"
                        onChange={handleItemChange}
                      >
                        <option value="" disabled defaultValue="">
                          {_lt(
                            `selectTheOptionThatBestDescribesYourOrganisation`,
                            language,
                          )}
                        </option>
                        {Object.entries(
                          getLocationDataOptions(`london`, `CLOUD_MOVE`),
                        ).map((opt, idx) => (
                          <option key={idx} value={opt[0]}>
                            {opt[1]}
                          </option>
                        ))}
                      </select>
                    </label>
                  </div>

                  <div
                    className={`col ${tm1paConference2025RegistrationFormStyles.valueChain}`}
                  >
                    <label htmlFor="whatPartsOfTheValueChainDoesTM1PlanningAnalyticsCurrentlyCoverInYourOrganisation">
                      {_lt(
                        `whatPartsOfTheValueChainDoesTM1PlanningAnalyticsCurrentlyCoverInYourOrganisation`,
                        language,
                      )}
                    </label>
                    <input
                      id="whatPartsOfTheValueChainDoesTM1PlanningAnalyticsCurrentlyCoverInYourOrganisation"
                      type="text"
                      className="form-control"
                      aria-label="What parts of the value chain does TM1 Planning Analytics currently cover in your Organisation?"
                      name="whatPartsOfTheValueChainDoesTM1PlanningAnalyticsCurrentlyCoverInYourOrganisation"
                      value={
                        data.whatPartsOfTheValueChainDoesTM1PlanningAnalyticsCurrentlyCoverInYourOrganisation
                      }
                      pattern="\S(.*\S)?"
                      onChange={handleItemChange}
                    />
                  </div>

                  <div
                    className={`col ${tm1paConference2025RegistrationFormStyles.frontend}`}
                  >
                    <label
                      className="form-check-label"
                      for="whichFrontEndsDoYouUseInYourNormalWorkflow"
                    >
                      {_lt(
                        `whichFrontEndsDoYouUseInYourNormalWorkflow`,
                        language,
                      )}
                    </label>
                    {data.whichFrontEndsDoYouUseInYourNormalWorkflow.map(
                      (it, idx) => (
                        <div key={idx} className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name={it.name}
                            checked={
                              data.whichFrontEndsDoYouUseInYourNormalWorkflow[
                                idx
                              ].checked
                            }
                            onChange={evt =>
                              handleItemChange(
                                evt,
                                `whichFrontEndsDoYouUseInYourNormalWorkflow`,
                              )
                            }
                          />
                          <label className="form-check-label">{it.name}</label>
                        </div>
                      ),
                    )}
                  </div>

                  <div
                    className={`col ${tm1paConference2025RegistrationFormStyles.valueChain}`}
                  >
                    <label htmlFor="doYouSeeADemandForAIMLInYourApplicationWhatProblemsShouldBeSolvedAddressedWithIt">
                      {_lt(
                        `doYouSeeADemandForAIMLInYourApplicationWhatProblemsShouldBeSolvedAddressedWithIt`,
                        language,
                      )}
                    </label>
                    <input
                      id="doYouSeeADemandForAIMLInYourApplicationWhatProblemsShouldBeSolvedAddressedWithIt"
                      type="text"
                      className="form-control"
                      aria-label="Do you see a demand for AI/ML in your application? What problems should be solved/addressed with it?"
                      name="doYouSeeADemandForAIMLInYourApplicationWhatProblemsShouldBeSolvedAddressedWithIt"
                      value={
                        data.doYouSeeADemandForAIMLInYourApplicationWhatProblemsShouldBeSolvedAddressedWithIt
                      }
                      pattern="\S(.*\S)?"
                      onChange={handleItemChange}
                    />
                  </div>

                  <div
                    className={`col ${tm1paConference2025RegistrationFormStyles.roundtable}`}
                  >
                    <label htmlFor="wePlanToOrganiseIndustryRoundTablesWhatFocusGroupWouldYouLikeToSeeOnTheAgenda">
                      {_lt(
                        `wePlanToOrganiseIndustryRoundTablesWhatFocusGroupWouldYouLikeToSeeOnTheAgenda`,
                        language,
                      )}
                    </label>
                    <textarea
                      className="form-control"
                      name="wePlanToOrganiseIndustryRoundTablesWhatFocusGroupWouldYouLikeToSeeOnTheAgenda"
                      rows="3"
                      pattern="\S(.*\S)?"
                      values={
                        data.wePlanToOrganiseIndustryRoundTablesWhatFocusGroupWouldYouLikeToSeeOnTheAgenda
                      }
                      onChange={handleItemChange}
                    ></textarea>
                  </div>

                  <div
                    className={`col ${tm1paConference2025RegistrationFormStyles.roundtable}`}
                  >
                    <label htmlFor="whatOtherTopicsWouldYouLikeToDiscussWithYourPeers">
                      {_lt(
                        `whatOtherTopicsWouldYouLikeToDiscussWithYourPeers`,
                        language,
                      )}
                    </label>
                    <textarea
                      className="form-control"
                      name="whatOtherTopicsWouldYouLikeToDiscussWithYourPeers"
                      rows="3"
                      pattern="\S(.*\S)?"
                      values={
                        data.whatOtherTopicsWouldYouLikeToDiscussWithYourPeers
                      }
                      onChange={handleItemChange}
                    ></textarea>
                  </div>
                  <div
                    className={`col ${tm1paConference2025RegistrationFormStyles.postEvent}`}
                  >
                    <label>
                      {_lt(
                        `wouldYouBeWillingToBeInterviewedAtTheConferencePleaseNoteAnyRecordingsMayBeUsedByCubewiseForMarketingPurposes`,
                        language,
                      )}
                    </label>
                    <div
                      className={
                        tm1paConference2025RegistrationFormStyles.eventAuthorisationWrapper
                      }
                    >
                      {data.eventAuthorisation.map((it, idx) => (
                        <div
                          key={idx}
                          className={`col ${tm1paConference2025RegistrationFormStyles.authorisationOptions}`}
                        >
                          <input
                            className="form-check-input"
                            type="radio"
                            name={it.name}
                            checked={data.eventAuthorisation[idx].checked}
                            onChange={evt =>
                              handleItemChange(evt, `eventAuthorisation`, true)
                            }
                          />
                          <label className="form-check-label">
                            {it.name.split(`-`)[1]}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                </>
              )}

              <div
                className={`col ${tm1paConference2025RegistrationFormStyles.info}`}
              >
                <p>{_lt(`mandatoryFields`, language)} *</p>
              </div>
              <div
                className={`col ${tm1paConference2025RegistrationFormStyles.validation}`}
              >
                <input
                  id="marketingAuthorisation"
                  type="checkbox"
                  className="form-check-input"
                  required
                  pattern="\S(.*\S)?"
                />
                <label htmlFor="marketingAuthorisation">
                  {_lt(`marketingAuthorisation`, language)}
                </label>
              </div>

              <div
                className={`col ${tm1paConference2025RegistrationFormStyles.validation}`}
              >
                <input
                  id="mediaPermission"
                  type="checkbox"
                  className="form-check-input"
                  required
                  pattern="\S(.*\S)?"
                />
                <label htmlFor="mediaPermission">
                  {_lt(`mediaPermission`, language)}
                </label>
              </div>
              <div
                className={`row ${tm1paConference2025RegistrationFormStyles.submitSection}`}
              >
                <div
                  className={`col ${tm1paConference2025RegistrationFormStyles.submitBtn}`}
                >
                  {!isSubmitting && (
                    <button
                      type="submit"
                      className={`${tm1paConference2025RegistrationFormStyles.btn}`}
                    >
                      {_lt(`register`, language)}
                    </button>
                  )}
                  {hasError && (
                    <p>
                      {_lt(
                        `anUnexpectedErrorHasOccurredPleaseConfirmAllDataToBeCorrectlyInputAndTryAgain`,
                        language,
                      )}
                    </p>
                  )}
                  {isSubmitted && (
                    <p>
                      {_lt(
                        `thankYouForYourInterestYouWillReceiveAnEmailWithTheConferenceDetails`,
                        language,
                      )}
                    </p>
                  )}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}

const getLocation = tag => {
  let location = DEFAULT_LOCATION
  const locations = tag.split(` `).filter(cn => cn.startsWith(`icw-evt`))
  if (locations.length > 0) {
    location = locations[0].replace(`icw-evt-`, ``).toLowerCase()
    if (!SUPPORTED_LOCATIONS.includes(location)) location = DEFAULT_LOCATION
  }

  return location
}

const getLanguage = location => {
  if (location === `paris`) {
    return `fr`
  }

  return `en`
}

const getCoreData = () => {
  return {
    businessEmail: ``,
    firstName: ``,
    lastName: ``,
    company: ``,
    contactNumber: ``,
    jobPosition: ``,
    dietaryRestrictions: ``,
  }
}

const getLocationData = location => {
  const coreData = getCoreData()
  const postEvent = [
    {
      name: `postEvent-Yes`,
      checked: false,
    },
    {
      name: `postEvent-No`,
      checked: true,
    },
  ]
  if (location !== `paris` && location !== `sydney` && location !== `melbourne` && location !== `melbourne2`) {
    coreData.postEvent = postEvent
  }

  if (location === `london`) {
    return {
      ...coreData,
      country: ``,
      whatVersionOfTM1PlanningAnalyticsAreYouUsing: ``,
      doesYourOrganisationPlanToMoveToACloudBasedSolutionForPlanningAnalytics: ``,
      whatPartsOfTheValueChainDoesTM1PlanningAnalyticsCurrentlyCoverInYourOrganisation: ``,
      whichFrontEndsDoYouUseInYourNormalWorkflow: [
        { name: `Perspectives`, checked: false },
        { name: `TM1Web`, checked: false },
        { name: `PAW`, checked: false },
        { name: `PAfE/PAX`, checked: false },
        { name: `Slice`, checked: false },
        { name: `Apliqo UX`, checked: false },
      ],
      doYouSeeADemandForAIMLInYourApplicationWhatProblemsShouldBeSolvedAddressedWithIt: ``,
      wePlanToOrganiseIndustryRoundTablesWhatFocusGroupWouldYouLikeToSeeOnTheAgenda: ``,
      whatOtherTopicsWouldYouLikeToDiscussWithYourPeers: ``,
      eventAuthorisation: [
        {
          name: `eventAuthorisation-Yes`,
          checked: false,
        },
        {
          name: `eventAuthorisation-No`,
          checked: true,
        },
      ],
    }
  }

  return coreData
}

const getLocationDataOptions = (location, kind) => {
  if (location === `london`) {
    switch (kind) {
      case `CLOUD_MOVE`:
        return {
          NO_PLAN: "No plan",
          PLANNED_NEAR_FUTURE: "Planned in the near future",
          PLANNED_NO_TIMELINE: "Planned but no timeline",
          ALREADY_CLOUD: "Already on a cloud platform",
          DO_NOT_KNOW: "I don't know",
        }
      default:
        return {}
    }
  }

  return {}
}

const getAirtableSettingsByLocation = location => {
  let airtableId = ``
  let airtableName = ``

  switch (location) {
    case `melbourne2`:
      airtableName = `AI in Finance - Melbourne [Registrations]`
      airtableId = `app9ybvrHaxoQBn8B`
      break
    case `melbourne`:
      airtableName = `MelbourneRegistration`
      airtableId = `apphzvs1AVHbJizqo`
      break
    case `london`:
      airtableName = `LondonRegistration`
      airtableId = `apphzvs1AVHbJizqo`
      break
    case `paris`:
      airtableName = `FranceRegistration`
      airtableId = `apphzvs1AVHbJizqo`
      break
    case `benelux`:
      airtableName = `BelgiumRegistration`
      airtableId = `apphzvs1AVHbJizqo`
      break
    case `sydney`:
    default:
      airtableName = `SydneyRegistration`
      airtableId = `apphzvs1AVHbJizqo`
  }

  return {
    airtableId,
    airtableName,
  }
}

const handleLocationData = (location, data) => {
  let locationData = {}

  switch (location) {
    case `melbourne`:
      locationData = _handleMelbourneData(data)
      break
    case `london`:
      locationData = _handleLondonData(data)
      break
    case `sydney`:
    default:
      locationData = _handleSydneyData(data)
  }

  return locationData
}

const _handleMelbourneData = data => {
  const dataKeys = Object.keys(data)
  const coreKeys = Object.keys(getCoreData())

  let localData = {}
  dataKeys.forEach(key => {
    if (coreKeys.includes(key)) return
    if (Array.isArray(data[key])) {
      // it's a multiple selection item
      if (data[key].length > 0 && data[key][0].hasOwnProperty(`checked`)) {
        // it's an array of checkboxes
        localData[key] = __handleCheckboxData(data, key)
      } else {
        // it's a single selection item
        localData[key] = data[key]
      }
    } else {
      // it's a single selection item
      localData[key] = data[key]
    }
  })

  return localData
}

const _handleLondonData = data => {
  const dataKeys = Object.keys(data)
  const coreKeys = Object.keys(getCoreData())

  let localData = {}
  dataKeys.forEach(key => {
    if (coreKeys.includes(key)) return
    if (Array.isArray(data[key])) {
      // it's a multiple selection item
      if (data[key].length > 0 && data[key][0].hasOwnProperty(`checked`)) {
        // it's an array of checkboxes
        localData[key] = __handleCheckboxData(data, key)
      } else {
        // it's a single selection item
        localData[key] = data[key]
      }
    } else {
      // it's a single selection item
      localData[key] = data[key]
    }
  })

  // handle country item special case
  localData[`country`] = ISOCountries.getName(data.country, `EN`)
  localData[`eventAuthorisation`] = localData.eventAuthorisation.split(`-`)[1]

  return localData
}

const _handleSydneyData = data => {
  const dataKeys = Object.keys(data)
  const coreKeys = Object.keys(getCoreData())

  let localData = {}
  dataKeys.forEach(key => {
    if (coreKeys.includes(key)) return
    if (Array.isArray(data[key])) {
      // it's a multiple selection item
      if (data[key].length > 0 && data[key][0].hasOwnProperty(`checked`)) {
        // it's an array of checkboxes
        localData[key] = __handleCheckboxData(data, key)
      } else {
        // it's a single selection item
        localData[key] = data[key]
      }
    } else {
      // it's a single selection item
      localData[key] = data[key]
    }
  })

  return localData
}

const __handleCheckboxData = (data, key) => {
  return data[key]
    .reduce((prev, curr) => {
      if (curr.checked) return [...prev, curr.name]
      return prev
    }, [])
    .toString()
}
